import BehavioralChart from './behavioral-chart';

export default BehavioralChart;
